export default __webpack_public_path__ + "static/media/R.a5d0772f.svg";